import { createAsyncThunk } from "@reduxjs/toolkit";
import { Auth } from "../libs/utilities/helpers/Auth";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { encryptData, decryptData } from "../libs/utilities/helpers/Crypto";
import { api } from "./config/axiosConfig";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_LOGIN;

export const login = createAsyncThunk(
  "auth/login",
  async ({ attar = {} }, { rejectWithValue }) => {
    try {
      // const encryptedPayload = await encryptData(JSON.stringify(attar));
      setBaseURL(api, DEV_BASE_URL);
      const response = await api.post("/user/login", attar);
      const encryptedString = response?.data?.data?.data;
      const decryptedString =  decryptData(encryptedString);
      const decryptedData = JSON.parse(decryptedString);
      const keyMap = {
      department: "Department",
      role: "Role",
      token: "Token",
      txn_id: "Txnid",
      user_id: "UserId",
      accessibility:"accessibility"
      };
const formattedData = Object.keys(decryptedData).reduce((acc, key) => {
  acc[keyMap[key] || key] = decryptedData[key];
  return acc;
}, {});
const encrypted =  encryptData(JSON.stringify(formattedData));
       Auth.register(encrypted.data);
      // const user = Auth.getUser({ auth: { user: encryptedString } });
      // return user;
       const user =  Auth.getUser();
    

      return user;
    } catch (error) {
      // handleApiError(error, 'login');
      return rejectWithValue(error.message);
    }
  });



export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
      const user = Auth.getUser();

      const response = await fetch(`${REACT_APP_BASE_URL}/api/v3.0/user/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "txn_id": user.UserId,
          "user_id": user.Txnid,
          "Authorization": `${user.Token}`,
        },
      });
      const data = await response.json();
      if (response.ok && data.success) {
        await Auth.deregister(dispatch);
        return {
          statusCode: response.status,
          message: data.message,
          data: data.data,
        };
      } else {
         return rejectWithValue(data.message || "Logout failed");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);